<template>
    <div class="shipping">
        <b-container>
            <div class="shipping-title">Opções de entrega</div>
            <b-row>
                <b-col cols="12" md="12" class="mb-3">
                    <ValidationObserver v-slot="{ handleSubmit }" slim ref="observer">
                        <form action="#" method="post" @submit.prevent="handleSubmit(listShipping)">
                            <ValidationProvider name="CEP" :rules="{ required: true, regex: /^\d{5}-?\d{3}$/ }" slim>
                                <div slot-scope="{ errors, classes, required }">
                                    <label for="cep"></label>
                                    <div class="input-group mb-2">
                                        <the-mask
                                            type="tel"
                                            class="form-control"
                                            id="cep"
                                            name="cep"
                                            :class="classes"
                                            v-model="cep"
                                            :mask="['#####-###']"
                                            :masked="true"
                                            style="min-height: 40px;"
                                        />
                                        <div class="input-group-append">
                                            <button type="submit" class="btn-default btn-square py-0">
                                                <div class="px-2">{{ sending_cep ? "Consultando" : "Consultar" }}</div>
                                            </button>
                                        </div>

                                    </div>
                                    <small v-show="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    <small
                                        v-show="shipping_msg"
                                        class="text-danger"
                                        v-html="shipping_msg"
                                    ></small>
                                </div>
                            </ValidationProvider>
                        </form>
                    </ValidationObserver>
                    <div v-if="cep_info.cep">
                        <div>
                            {{ cep_info.tipo_logradouro }} {{ cep_info.logradouro }}
                        </div>
                        <div>
                            {{ cep_info.bairro }}
                        </div>
                        <div>
                            {{ cep_info.cidade }} -
                            <span class="text-uppercase">{{ cep_info.uf }}</span>
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="shipping_condition.id && shipping_condition.valor_diferenca > 0">
                        Adicione mais <b>{{ shipping_condition.valor_diferenca | currency }}</b>
                        para obter
                        <b v-if="shipping_condition.valor_fixo">
                            frete de {{ shipping_condition.valor_fixo | currency }}
                        </b>
                        <b v-else>frete gr&aacute;tis</b>
                    </div>
                </b-col>
                <div class="mb-3 w-100 pr-3">
                    <b-col cols="12" v-for="(shipping_item, index) in shipping_list" :key="shipping_item.id" class="pb-2 mb-2 ml-3">
                        <b-row>
                            <b-col cols="8" md="6" class="pl-0 pr-0">
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="shipping"
                                        :id="'shipping' + shipping_item.id"
                                        :value="parseInt(shipping_item.id)"
                                        v-model="shipping_id"
                                    />
                                    <label
                                        class="form-check-label shipping-options"
                                        :for="'shipping' + shipping_item.id"
                                        v-html="shipping_item.label ? shipping_item.label : shipping_item.nome_frete"
                                    ></label>
                                    <div class="shipping_description ml-2 mt-1">
                                        <div
                                            class="delivery_period"
                                            v-if="parseInt(shipping_item.dias_frete) > 0"
                                        >
                                            {{ shipping_item.dias_frete_exibicao }}
                                        </div>
                                        <div class="shipping-options" v-html="shipping_item.descricao"></div>
                                        <div class="form-group" v-if="parseInt(shipping_item.id_tipo) === 2 && shipping_id === parseInt(shipping_item.id)">
                                            <select
                                                name="carrier"
                                                :id="'carrier' + shipping_item.id"
                                                class="form-control shipping-form-control"
                                                @change="changeShipping"
                                                v-model="carrier_id"
                                            >
                                                <option value="0" disabled>Selecione</option>
                                                <option
                                                    :value="parseInt(opcao.id)"
                                                    v-for="opcao in shipping_item.lista_valores"
                                                    :key="opcao.id"
                                                >
                                                    {{ opcao.nome }} -
                                                    {{ opcao.valor | currency }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col cols="4" md="6">
                                <div v-if="parseInt(shipping_item.id_tipo) === 2 && shipping_id === parseInt(shipping_item.id) && carrier_id > 0" class="text-right shipping-price">
                                    <b>{{ shipping_item.lista_valores[carrier_id].valor | currency }}</b>
                                </div>
                                <div v-else-if="shipping_item.id_tipo == 2"></div>
                                <div v-else-if="shipping_item.valor_frete == '0.00'" style="color:#007f00;" class="text-right">
                                    <b class="text-right shipping-price">Grátis</b>
                                </div>
                                <div v-else class="text-right shipping-price">
                                    <b>{{ shipping_item.valor_frete | currency }}</b>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </div>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import ecommerce_shipping from "~/mixins/ecommerce_shipping";
import ecommerce_cart from "~/mixins/ecommerce_cart.js";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { TheMask } from "vue-the-mask";
import Cookies from 'js-cookie';
export default{
    components: {
        ValidationProvider,
        ValidationObserver,
        TheMask
    },
    mixins: [
        ecommerce_shipping,
        ecommerce_cart
    ],
    mounted() {
        if (Cookies.get("shipping_cep")) {
            this.cep = Cookies.get("shipping_cep")
            this.listShipping()
        }
    },

}
</script>
